<script lang="ts" setup>
import AttributeForm from "@/data-views/forms/attribute/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "Attribute",
  },
});
</script>

<template>
  <div>
    <AttributeForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
